import React from 'react';

import { PartnersTableItem } from 'types/state';
import { TableTr, TableTd } from 'design/table';
import { useIntlDictionary } from 'hooks/useIntlDictionary';

type Props = {
  item: PartnersTableItem;
  active: boolean;
  onClick(id: number): void;
};

export const PartnersTableRow = (props: Props) => {
  const { item, active, onClick } = props;

  const { partnersTable, shared: sharedDitctionary } = useIntlDictionary();

  const disabled = item.status === 'CANDIDATE';

  const onRowClick = React.useCallback(() => {
    onClick(item.id);
  }, [onClick, item.id]);

  return (
    <TableTr active={active} disabled={disabled} onClick={onRowClick}>
      <TableTd text={`${item.id}`} />
      <TableTd text={item.fullName} />
      <TableTd text={item.email} />
      <TableTd text={item.phone} />
      <TableTd text={partnersTable.statusText(item.status)} />
      <TableTd text={`${item.clientsCount}`} />
      <TableTd
        text={sharedDitctionary.moneyAmountText(item.earnedAmount, 'USD')}
      />
      <TableTd
        text={sharedDitctionary.moneyAmountText(item.paidAmount, 'USD')}
      />
      <TableTd text={sharedDitctionary.moneyAmountText(item.balance, 'USD')} />
      <TableTd
        text={partnersTable.latestUpdateDateText(item.latestUpdateDate)}
      />
    </TableTr>
  );
};
